// extracted by mini-css-extract-plugin
export default {"imageContainer":"l2-z","summaryPar":"m2-z","ratingCategories":"n2-z","reviewerInfo":"o2-z","reviewTypes":"p2-z","expanded":"q2-z"};